import {
	Column,
	DataGrid,
	FilterRow,
	GroupItem,
	Grouping,
	Pager,
	Paging,
	SortByGroupSummaryInfo,
	Sorting,
	Summary,
} from 'devextreme-react/data-grid';
import DateBox from 'devextreme-react/date-box';
import SelectBox from 'devextreme-react/select-box';
import Toolbar, { Item } from 'devextreme-react/toolbar';
import moment from 'moment';
import React, { useCallback, useEffect, useMemo, useRef, useState } from 'react';
import { useSelector } from 'react-redux';
import { Transition } from 'semantic-ui-react';
import { busTuyenDuongApi } from '../../../api/bus/busTuyenDuongApi';
import { DefaultButton } from '../../../components/editor/button';
import PlaceHolder from '../../../components/place-holder';
import { useCommonContext } from '../../../contexts/common';
import './BusDiemDanhBaoCaoPage.css';
import styles from './BusDiemDanhBaoCaoPage.module.css';

const dfTuyenDuongChiTietModel = {
	id: 0,
	bus_tuyenduong_id: 0,
	diachi_diemdon: '',
	diachi_diemtra: '',
	bus_diemdontra_id: 0,
	thoi_gian_don: '00:00',
	thoi_gian_tra: '00:00',
	idx_diemdon: 99,
	idx_diemtra: 99,
	ghi_chu: '',
	bus_loaidiemdon_id: 0,
};

const BusDiemDanhBaoCaoPage = () => {
	const { nam_hoc } = useSelector((x) => x.namHoc);
	const { dm_coso_id } = useSelector((x) => x.coSo);
	const grid = useRef(null);
	const { canAccessTo, translate } = useCommonContext();
	const [filter, setFilter] = useState({
		dm_coso_id: dm_coso_id,
		bus_tuyenduong_id: 0,
		nam_hoc: nam_hoc,
		ngay_diem_danh: moment().format(),
	});
	const [isLoading, setIsLoading] = useState(false);
	const [dsTuyenDuongs, setDSTuyenDuongs] = useState([]);
	const [dsHocSinhPhanTuyens, setDSHocSinhPhanTuyens] = useState([]);

	const handleReloadPhanTuyens = async () => {
		setIsLoading(true);
		const res = await busTuyenDuongApi.SelectBaoCaoDiemDanhAsync(filter);
		setIsLoading(false);
		if (res.is_success) {
			setDSHocSinhPhanTuyens(res.data);
		} else {
			setDSHocSinhPhanTuyens([]);
		}
	};

	const handleReloadTuyenDuongs = useCallback(async () => {
		const res = await busTuyenDuongApi.SelectAsync({ nam_hoc, dm_coso_id });
		if (res.is_success) {
			setDSTuyenDuongs(res.data);
		} else {
			setDSTuyenDuongs([]);
		}
	}, [nam_hoc, dm_coso_id]);

	useEffect(() => {
		handleReloadPhanTuyens();
	}, [filter]);

	useEffect(() => {
		setFilter((prev) => ({ ...prev, dm_coso_id: dm_coso_id, nam_hoc: nam_hoc }));
		handleReloadTuyenDuongs();
	}, [nam_hoc, dm_coso_id]);

	const dsHocSinhPhanTuyensReOrder = useMemo(() => {
		return dsHocSinhPhanTuyens.sort((a, b) => (a.idx_diemdon < b.idx_diemdon ? -1 : 1));
	}, [dsHocSinhPhanTuyens]);

	return (
		<React.Fragment>
			<Transition animation='scale' visible={true} duration={200} transitionOnMount={true}>
				<div>
					<div className='row'>
						<div className='col-md-12 padding-top-1rem padding-left-2rem'>
							<Toolbar className='bg-background'>
								<Item
									location='before'
									render={() => {
										return (
											<DateBox
												placeholder={translate('Ngày điểm danh')}
												value={filter.ngay_diem_danh}
												stylingMode='outlined'
												displayFormat={'dd/MM/yyyy'}
												type='date'
												onValueChanged={(e) => {
													if (e.event) {
														if (e.event) setFilter((prev) => ({ ...prev, ngay_diem_danh: e.value || 0 }));
													}
												}}
												width={200}
											/>
										);
									}}
								/>
								<Item
									location='before'
									render={() => {
										return (
											<SelectBox
												dataSource={dsTuyenDuongs}
												displayExpr={'ten_tuyen_viet_tat'}
												valueExpr={'id'}
												value={filter.bus_tuyenduong_id}
												stylingMode='outlined'
												readOnly={false}
												placeholder={translate('Chọn tuyến đường')}
												width='100%'
												showClearButton={true}
												onValueChanged={(e) => {
													if (e.event) setFilter((prev) => ({ ...prev, bus_tuyenduong_id: e.value || 0 }));
												}}
											/>
										);
									}}
								/>

								<Item
									location='after'
									render={() => {
										return (
											<DefaultButton
												text={'Tải lại dữ liệu'}
												icon={'fas fa-sync-alt'}
												onClick={() => {
													handleReloadPhanTuyens();
													handleReloadTuyenDuongs();
												}}
											/>
										);
									}}
								/>
								<Item
									location='after'
									locateInMenu={'auto'}
									render={() => {
										return (
											<DefaultButton
												text={'Xuất Excel'}
												icon='fas fa-file'
												onClick={() => grid.current.instance.exportToExcel()}
											/>
										);
									}}
								/>
							</Toolbar>
						</div>
						<div className='col-md-12 padding-top-1rem'>
							{isLoading && <PlaceHolder line_number={20} />}
							{!isLoading && (
								<DataGrid
									ref={grid}
									dataSource={dsHocSinhPhanTuyensReOrder}
									columnHidingEnabled={false}
									columnAutoWidth={false}
									showBorders={true}
									showColumnLines={true}
									showRowLines={true}
									rowAlternationEnabled={true}
									allowColumnResizing={true}
									columnResizingMode={'nextColumn'}
									hoverStateEnabled={true}
									focusedRowEnabled={false}
									height={window.innerHeight - 150}
									className={'table-noborder-left'}
									wordWrapEnabled={false}
								>
									<Sorting mode='multiple' />
									<Paging defaultPageSize={50} />
									<Grouping autoExpandAll={true} />
									<FilterRow visible={true} />
									<Summary>
										<GroupItem column='ma_tuyen' summaryType='min' />
										<GroupItem column='ts_hocsinh_id' summaryType='count' />
									</Summary>
									<SortByGroupSummaryInfo summaryItem='min' />
									<Pager
										showPageSizeSelector={true}
										allowedPageSizes={[10, 20, 50, 200, 500]}
										infoText={`${translate('Trang')} {0} /{1} ({2} ${translate('dòng')})`}
										showInfo={true}
									/>
									<Column
										dataField='bus_tuyenduong_id'
										caption={translate('Tên Tuyến')}
										groupIndex={0}
										width={100}
										groupCellRender={(cell) => {
											const tuyenDuong = dsTuyenDuongs.find((x) => x.id == cell.value);
											let countHocSinhs = 0;
											if (cell.data.items) {
												countHocSinhs = cell.data.items.filter((x) => x.ts_hocsinh_id > 0).length;
											}
											return (
												<>
													{tuyenDuong ? (
														<>
															<div className={`row mx-0 ${styles.tuyen_duong}`}>
																<div className='col-md-3'>
																	<span>
																		{/* <LinkButton
																			icon={'fa fa-edit'}
																			onClick={() => {
																				setShowDetailTuyenDuong(true);
																				setTuyenDuongDetailSelected(tuyenDuong);
																			}}
																		/> */}
																		Mã tuyến: <b className={`${styles.ten_tuyen_duong}`}>{tuyenDuong?.ma_tuyen}</b>{' '}
																	</span>
																	<br></br>
																	<span>
																		Tên tuyến:{' '}
																		<b className={`${styles.ten_tuyen_duong}`}>{tuyenDuong?.ten_tuyen_viet_tat}</b>{' '}
																	</span>
																	<br></br>
																	Tổng: <b>{countHocSinhs || 0}</b> học sinh
																</div>
																<div className='col-md-2'>
																	{tuyenDuong?.bus_xe && (
																		<>
																			<div>
																				Xe: <b>{tuyenDuong?.bus_xe?.bien_so}</b>
																				<br></br>
																				<b>
																					{tuyenDuong?.bus_xe?.nhan_hieu_xe || 'Nhãn hiệu'}{' '}
																					{tuyenDuong?.bus_xe?.so_ghe || 0} chỗ
																				</b>
																			</div>
																		</>
																	)}
																</div>
																<div className='col-md-2'>
																	{tuyenDuong?.bus_laixe && (
																		<>
																			<div>
																				Tài xế: <b>{tuyenDuong?.bus_laixe?.ho_ten}</b>
																				<br></br>
																				SĐT: <b>{tuyenDuong?.bus_laixe?.dien_thoai}</b>
																			</div>
																		</>
																	)}
																</div>
																<div className='col-md-2'>
																	{tuyenDuong?.bus_monitoring && (
																		<>
																			<div>
																				Mo: <b>{tuyenDuong?.bus_monitoring?.ho_ten}</b>
																				<br></br>
																				SĐT: <b>{tuyenDuong?.bus_monitoring?.dien_thoai}</b>
																			</div>
																		</>
																	)}
																</div>
															</div>
														</>
													) : (
														<></>
													)}
												</>
											);
										}}
									></Column>
									<Column dataField='diem_don_tra' caption={translate('Điểm đón')} minWidth={300}></Column>

									<Column dataField='ma_hs' caption={translate('Mã học sinh')} width={120}></Column>
									<Column dataField='ten_lop' caption={translate('Lớp')} width={120}></Column>
									<Column dataField='ho_ten' caption={translate('Họ tên')} width={180}></Column>
									<Column
										dataField='ma_tuyen'
										caption={'Tuyến xe'}
										width={180}
										cellRender={(cell) => {
											const tuyenDuong = dsTuyenDuongs.find((x) => x.ma_tuyen == cell.data.ma_tuyen);
											return (
												<div className={`ten_tuyen_duong`}>{tuyenDuong?.ten_tuyen_viet_tat || ''}</div>
											);
										}}
									></Column>
									{/* <Column dataField='ten_tuyen' caption={translate('Tuyến xe')} width={180}></Column> */}
									<Column dataField='bus_hinhthuc_dangky' caption={translate('Hình thức đăng ký')} width={180}></Column>

									<Column
										dataField='trangthai_diemdanh_chitiet'
										caption={translate('Trạng thái điểm danh')}
										width={150}
										alignment={'center'}
									></Column>
									<Column caption={translate('Thời gian')}>
										<Column
											dataField='gio_don'
											caption={translate('Giờ lên xe đi')}
											dataType={'datetime'}
											format={'HH:mm'}
											alignment={'center'}
											minWidth={100}
										></Column>
										<Column
											dataField='gio_don_ket_thuc'
											caption={translate('Giờ đến trường')}
											dataType={'datetime'}
											format={'HH:mm'}
											alignment={'center'}
											minWidth={100}
										></Column>
										<Column
											dataField='gio_tra'
											caption={translate('Giờ lên xe về')}
											dataType={'datetime'}
											format={'HH:mm'}
											alignment={'center'}
											minWidth={100}
										></Column>
										<Column
											dataField='gio_tra_ket_thuc'
											caption={translate('Giờ đến nhà')}
											dataType={'datetime'}
											format={'HH:mm'}
											alignment={'center'}
											minWidth={100}
										></Column>
									</Column>
								</DataGrid>
							)}
						</div>
					</div>
				</div>
			</Transition>
		</React.Fragment>
	);
};
export default BusDiemDanhBaoCaoPage;
